import React, { useCallback } from 'react';

import PrivateGallery from '../anchorComponents/PrivateGalleriesAndVideos/PrivateGallery';
import PrivateVideo from '../anchorComponents/PrivateGalleriesAndVideos/PrivateVideo';

import './PrivateContent.css';


const PrivateContent = (props) => {
  const {
    galleriesAndVideos,
    subscribed,
    anchorId,
    user,
    anchorShortUrl,
    needClasses = false,
    videoClass,
  } = props;

  const contentToRender = useCallback((item) => {
    if (item.type === 'VIDEO') {
      return (
        <PrivateVideo
          key={item.id}
          anchorId={anchorId}
          anchorShortUrl={anchorShortUrl}
          coverPhoto={item.imageUrl}
          date={item.date}
          liveEvents={true}
          media={item}
          needClasses={needClasses}
          showDescription={false}
          subscribed={subscribed}
          title={item.title}
          user={user}
          videoClass={videoClass}
        />
      );
    }

    return (
      <PrivateGallery
        key={item.id}
        anchorId={anchorId}
        anchorShortUrl={anchorShortUrl}
        coverPhoto={item.imageUrl}
        imageCount={item.imageCount}
        liveEvents={true}
        media={item}
        showDescription={false}
        subscribed={subscribed}
        title={item.title}
      />
    );
  }, [anchorId, anchorShortUrl, needClasses, subscribed, user, videoClass]);

  const AllMediaItems = useCallback(() =>
    galleriesAndVideos.map((item) =>
      contentToRender(item)), [galleriesAndVideos, contentToRender]);

  return (
    <div>
      <AllMediaItems />
    </div>
  );
};

export default PrivateContent;
